import { RatingEnum, RecommendationEnum } from "@finway-group/shared/lib/models"
import { validObjectId, phoneNumber, VAT, BIC, IBAN } from "./shared"

export const contractURL = ""
export const prefixURL = ""

export const vendorAmazonData: any = {
    id: validObjectId,
    name: "Amazon",
    description: "Online market for general purposes",
    rating: RatingEnum.FIVE_STARS,
    recommendation: RecommendationEnum.FINE,
    streetName: "Maxwell street",
    streetNumber: 13,
    city: "Salt Lake City",
    zip: "999999",
    country: "US",
    taxNumber: "365728",
    vatNumber: VAT,
    contactPersonName: "Fred Feuerstein",
    contactPersonEmail: "ffeuerstein@vendor.com",
    contactPersonPhone: phoneNumber,
    iban: IBAN,
    bic: BIC,
    img: "default.jpg",
    contracts: [contractURL],
}

export const vendorEbayData: any = {
    id: "209382697352011920938269",
    name: "Ebay",
    description: "Alternative to Amazon",
    rating: RatingEnum.TWO_STARS,
    recommendation: RecommendationEnum.BLACK_LIST,
    streetName: "Maxwell street",
    streetNumber: 13,
    city: "Salt Lake City",
    zip: "999999",
    country: "US",
    taxNumber: "365728",
    vatNumber: VAT,
    contactPersonName: "Fred Feuerstein",
    contactPersonEmail: "ffeuerstein@vendor.com",
    contactPersonPhone: phoneNumber,
    iban: IBAN,
    bic: BIC,
    img: "default.jpg",
    contracts: [],
}

export const vendorSlackData: any = {
    id: "209382697352111920938269",
    name: "Slack LLC",
    description: "Company chatting tool",
    rating: RatingEnum.FOUR_STARS,
    recommendation: RecommendationEnum.FINE,
    streetName: "Maxwell street",
    streetNumber: 13,
    city: "Salt Lake City",
    zip: "999999",
    country: "US",
    taxNumber: "365728",
    vatNumber: VAT,
    contactPersonName: "Fred Feuerstein",
    contactPersonEmail: "ffeuerstein@vendor.com",
    contactPersonPhone: phoneNumber,
    iban: IBAN,
    bic: BIC,
    img: "default.jpg",
    contracts: [],
}

export const vendorAdobeData: any = {
    id: "209382697352511920938269",
    name: "Adobe",
    description: "Creative Suit Seller",
    rating: RatingEnum.FIVE_STARS,
    recommendation: RecommendationEnum.FINE,
    streetName: "Maxwell street",
    streetNumber: 13,
    city: "Salt Lake City",
    zip: "999999",
    country: "US",
    taxNumber: "365728",
    vatNumber: VAT,
    contactPersonName: "Fred Feuerstein",
    contactPersonEmail: "ffeuerstein@vendor.com",
    contactPersonPhone: phoneNumber,
    iban: IBAN,
    bic: BIC,
    img: "default.jpg",
    contracts: [],
}

export const vendorGoogleData: any = {
    id: "209382697352611920938269",
    name: "Google",
    description: "Tech Giant",
    rating: RatingEnum.FOUR_STARS,
    recommendation: RecommendationEnum.FINE,
    streetName: "Maxwell street",
    streetNumber: 13,
    city: "Salt Lake City",
    zip: "999999",
    country: "US",
    taxNumber: "365728",
    vatNumber: VAT,
    contactPersonName: "Fred Feuerstein",
    contactPersonEmail: "ffeuerstein@vendor.com",
    contactPersonPhone: phoneNumber,
    iban: IBAN,
    bic: BIC,
    img: "default.jpg",
    contracts: [contractURL],
}

export const vendorMicrosoftData: any = {
    id: "209382697352711920938269",
    name: "Microsoft",
    description: "Tech giant",
    rating: RatingEnum.THREE_STARS,
    recommendation: RecommendationEnum.FINE,
    streetName: "Maxwell street",
    streetNumber: 13,
    city: "Salt Lake City",
    zip: "999999",
    country: "US",
    taxNumber: "365728",
    vatNumber: VAT,
    contactPersonName: "Fred Feuerstein",
    contactPersonEmail: "ffeuerstein@vendor.com",
    contactPersonPhone: phoneNumber,
    iban: IBAN,
    bic: BIC,
    img: "default.jpg",
    contracts: [contractURL],
}

export const vendorTelecomData: any = {
    id: "209382697352821920938269",
    name: "Telecom",
    description: "Cellular provider",
    rating: RatingEnum.ONE_STAR,
    recommendation: RecommendationEnum.BLACK_LIST,
    streetName: "Maxwell street",
    streetNumber: 13,
    city: "Salt Lake City",
    zip: "999999",
    country: "US",
    taxNumber: "365728",
    vatNumber: VAT,
    contactPersonName: "Fred Feuerstein",
    contactPersonEmail: "ffeuerstein@vendor.com",
    contactPersonPhone: phoneNumber,
    iban: IBAN,
    bic: BIC,
    img: "default.jpg",
    contracts: [],
}
